export function ChartLegend({ items }) {
    return (
        <div className="d-flex gap-4 flex-center flex-wrap mb-4">
            {items.map((item) => (
                <div key={item.label} className="badge badge-lg text-dark">
                    <i className="fas fa-circle me-1" style={{ color: item.color }} />
                    &nbsp;{item.label}
                </div>
            ))}
        </div>
    )
}
